"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = require("styled-components");
var default_1 = __importDefault(require("../assets/styles/default"));
var typography_1 = __importDefault(require("./typography"));
var shadows_1 = __importDefault(require("./shadows"));
var noShadows_1 = __importDefault(require("./noShadows"));
var CompassGlobalStyles = (0, styled_components_1.createGlobalStyle)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n\n    :root {\n      --background: ", ";\n      --white: ", ";\n      --blue-light: ", ";\n      --blue: ", ";\n      --blue-dark: ", ";\n      --black: ", ";\n      --steel: ", ";\n      --concrete: ", ";\n      --whale-light: ", ";\n      --whale: ", ";\n      --whale-dark: ", ";\n      --smoke-darker: ", ";\n      --smoke-dark: ", ";\n      --smoke: ", ";\n      --snow-darker: ", ";\n      --snow-dark: ", ";\n      --snow: ", ";\n      --success: ", ";\n      --danger: ", ";\n      --danger-dark: ", ";\n      --warning: ", ";\n      --green-light: ", ";\n      --green: ", ";\n      --green-dark: ", ";\n      --turquoise-light: ", ";\n      --turquoise: ", ";\n      --turquoise-dark: ", ";\n      --turquoise-15: ", ";\n      --turquoise-30: ", ";\n      --pink-light: ", ";\n      --pink: ", ";\n      --pink-dark: ", ";\n      --cyan-light: ", ";\n      --meteor: ", ";\n      --navy: ", ";\n      --ozone: ", ";\n      --gold: ", ";\n      --gold-light: ", ";\n      --red-dark: ", ";\n      --red-dark-10: ", ";\n      --red-light: ", ";\n      --lake: ", ";\n      --perf-green: ", ";\n      --attention: ", ";\n      --turquoise-80: ", ";\n      --danger-80: ", ";\n      --attention-15: ", ";\n      --attention-40: ", ";\n      --snow-darker-25: ", ";\n      --danger-5: ", ";\n      --danger-15: ", ";\n      --danger-40: ", ";\n      --turquoise-5: ", ";\n      --purple: ", ";\n      --purple-15: ", ";\n      --purple-40: ", ";\n\n    }\n   ", "\n   ", "\n   ", ";\n\n  :root {\n    --header-size-max: 13.6rem;\n    --header-size-woTabs: 6.8rem;\n  }\n\n  * {\n     box-sizing: border-box;\n     outline: none;\n   }\n\n   body,\n   input,\n   select,\n   textarea,\n   button {\n     /* font-size: 14px; */\n     -webkit-font-smoothing: antialiased;\n     -moz-osx-font-smoothing: grayscale;\n     /* font-weight: 400;\n     line-height: 1.2em; */\n     margin: 0;\n     // padding: 0;\n     // background: ", ";\n   }\n\n   #app {\n     display: flex;\n     flex-direction: column;\n     height: 100vh;\n     width: 100vw;\n     overflow: hidden;\n     overflow-x: auto;\n     background: ", ";\n   }\n\n   .AdminMain {\n     height: 100%;\n     width: 100%;\n   }\n\n   *::-webkit-scrollbar {\n     width: 1rem;\n     right: 10rem;\n   }\n\n   *::-webkit-scrollbar-track {\n     background: transparent;\n   }\n\n   *::-webkit-scrollbar-thumb {\n     border-radius: 6px;\n     background: ", ";\n     opacity: 0.6;\n   }\n\n   .space-reserve-title::after {\n     display: block;\n     content: attr(title);\n     font-weight: 500;\n     height: 0;\n     overflow: hidden;\n     visibility: hidden;\n   }\n\n   .token.bold {\n     font-weight: 900;\n     color: ", ";\n   }\n\n   .token.code {\n     font-family: monospace;\n     background: ", ";\n     padding: 0 0.4rem;\n   }\n\n   .token.italic {\n     font-style: italic;\n   }\n\n   .token.strike {\n     text-decoration: line-through;\n   }\n\n   .token.punctuation {\n     display: none;\n   }\n\n   .HighlightMarkup .emoji-mart-emoji {\n     line-height: 0.2rem;\n   }\n\n   .HighlightMarkup .emoji-mart-emoji span {\n     height: 1.6rem !important;\n     width: 1.6rem !important;\n   }\n\n   @-webkit-keyframes rotating /* Safari and Chrome */ {\n     from {\n       -webkit-transform: rotate(0deg);\n       -o-transform: rotate(0deg);\n       transform: rotate(0deg);\n     }\n     to {\n       -webkit-transform: rotate(360deg);\n       -o-transform: rotate(360deg);\n       transform: rotate(360deg);\n     }\n   }\n   @keyframes rotating {\n     from {\n       -ms-transform: rotate(0deg);\n       -moz-transform: rotate(0deg);\n       -webkit-transform: rotate(0deg);\n       -o-transform: rotate(0deg);\n       transform: rotate(0deg);\n     }\n     to {\n       -ms-transform: rotate(360deg);\n       -moz-transform: rotate(360deg);\n       -webkit-transform: rotate(360deg);\n       -o-transform: rotate(360deg);\n       transform: rotate(360deg);\n     }\n   }\n   .search-highlighter {\n     background: ", ";\n   }\n   .react-tooltip-clickable-link {\n     pointer-events: auto\n    }\n"], ["\n  ", "\n\n    :root {\n      --background: ", ";\n      --white: ", ";\n      --blue-light: ", ";\n      --blue: ", ";\n      --blue-dark: ", ";\n      --black: ", ";\n      --steel: ", ";\n      --concrete: ", ";\n      --whale-light: ", ";\n      --whale: ", ";\n      --whale-dark: ", ";\n      --smoke-darker: ", ";\n      --smoke-dark: ", ";\n      --smoke: ", ";\n      --snow-darker: ", ";\n      --snow-dark: ", ";\n      --snow: ", ";\n      --success: ", ";\n      --danger: ", ";\n      --danger-dark: ", ";\n      --warning: ", ";\n      --green-light: ", ";\n      --green: ", ";\n      --green-dark: ", ";\n      --turquoise-light: ", ";\n      --turquoise: ", ";\n      --turquoise-dark: ", ";\n      --turquoise-15: ", ";\n      --turquoise-30: ", ";\n      --pink-light: ", ";\n      --pink: ", ";\n      --pink-dark: ", ";\n      --cyan-light: ", ";\n      --meteor: ", ";\n      --navy: ", ";\n      --ozone: ", ";\n      --gold: ", ";\n      --gold-light: ", ";\n      --red-dark: ", ";\n      --red-dark-10: ", ";\n      --red-light: ", ";\n      --lake: ", ";\n      --perf-green: ", ";\n      --attention: ", ";\n      --turquoise-80: ", ";\n      --danger-80: ", ";\n      --attention-15: ", ";\n      --attention-40: ", ";\n      --snow-darker-25: ", ";\n      --danger-5: ", ";\n      --danger-15: ", ";\n      --danger-40: ", ";\n      --turquoise-5: ", ";\n      --purple: ", ";\n      --purple-15: ", ";\n      --purple-40: ", ";\n\n    }\n   ", "\n   ", "\n   ", ";\n\n  :root {\n    --header-size-max: 13.6rem;\n    --header-size-woTabs: 6.8rem;\n  }\n\n  * {\n     box-sizing: border-box;\n     outline: none;\n   }\n\n   body,\n   input,\n   select,\n   textarea,\n   button {\n     /* font-size: 14px; */\n     -webkit-font-smoothing: antialiased;\n     -moz-osx-font-smoothing: grayscale;\n     /* font-weight: 400;\n     line-height: 1.2em; */\n     margin: 0;\n     // padding: 0;\n     // background: ", ";\n   }\n\n   #app {\n     display: flex;\n     flex-direction: column;\n     height: 100vh;\n     width: 100vw;\n     overflow: hidden;\n     overflow-x: auto;\n     background: ", ";\n   }\n\n   .AdminMain {\n     height: 100%;\n     width: 100%;\n   }\n\n   *::-webkit-scrollbar {\n     width: 1rem;\n     right: 10rem;\n   }\n\n   *::-webkit-scrollbar-track {\n     background: transparent;\n   }\n\n   *::-webkit-scrollbar-thumb {\n     border-radius: 6px;\n     background: ", ";\n     opacity: 0.6;\n   }\n\n   .space-reserve-title::after {\n     display: block;\n     content: attr(title);\n     font-weight: 500;\n     height: 0;\n     overflow: hidden;\n     visibility: hidden;\n   }\n\n   .token.bold {\n     font-weight: 900;\n     color: ", ";\n   }\n\n   .token.code {\n     font-family: monospace;\n     background: ", ";\n     padding: 0 0.4rem;\n   }\n\n   .token.italic {\n     font-style: italic;\n   }\n\n   .token.strike {\n     text-decoration: line-through;\n   }\n\n   .token.punctuation {\n     display: none;\n   }\n\n   .HighlightMarkup .emoji-mart-emoji {\n     line-height: 0.2rem;\n   }\n\n   .HighlightMarkup .emoji-mart-emoji span {\n     height: 1.6rem !important;\n     width: 1.6rem !important;\n   }\n\n   @-webkit-keyframes rotating /* Safari and Chrome */ {\n     from {\n       -webkit-transform: rotate(0deg);\n       -o-transform: rotate(0deg);\n       transform: rotate(0deg);\n     }\n     to {\n       -webkit-transform: rotate(360deg);\n       -o-transform: rotate(360deg);\n       transform: rotate(360deg);\n     }\n   }\n   @keyframes rotating {\n     from {\n       -ms-transform: rotate(0deg);\n       -moz-transform: rotate(0deg);\n       -webkit-transform: rotate(0deg);\n       -o-transform: rotate(0deg);\n       transform: rotate(0deg);\n     }\n     to {\n       -ms-transform: rotate(360deg);\n       -moz-transform: rotate(360deg);\n       -webkit-transform: rotate(360deg);\n       -o-transform: rotate(360deg);\n       transform: rotate(360deg);\n     }\n   }\n   .search-highlighter {\n     background: ", ";\n   }\n   .react-tooltip-clickable-link {\n     pointer-events: auto\n    }\n"])), default_1.default, function (_a) {
    var theme = _a.theme;
    return theme.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.blueLight;
}, function (_a) {
    var theme = _a.theme;
    return theme.blue;
}, function (_a) {
    var theme = _a.theme;
    return theme.blueDark;
}, function (_a) {
    var theme = _a.theme;
    return theme.black;
}, function (_a) {
    var theme = _a.theme;
    return theme.steel;
}, function (_a) {
    var theme = _a.theme;
    return theme.concrete;
}, function (_a) {
    var theme = _a.theme;
    return theme.whaleLight;
}, function (_a) {
    var theme = _a.theme;
    return theme.whale;
}, function (_a) {
    var theme = _a.theme;
    return theme.whaleDark;
}, function (_a) {
    var theme = _a.theme;
    return theme.smokeDarker;
}, function (_a) {
    var theme = _a.theme;
    return theme.smokeDark;
}, function (_a) {
    var theme = _a.theme;
    return theme.smoke;
}, function (_a) {
    var theme = _a.theme;
    return theme.snowDarker;
}, function (_a) {
    var theme = _a.theme;
    return theme.snowDark;
}, function (_a) {
    var theme = _a.theme;
    return theme.snow;
}, function (_a) {
    var theme = _a.theme;
    return theme.success;
}, function (_a) {
    var theme = _a.theme;
    return theme.danger;
}, function (_a) {
    var theme = _a.theme;
    return theme.dangerDark;
}, function (_a) {
    var theme = _a.theme;
    return theme.warning;
}, function (_a) {
    var theme = _a.theme;
    return theme.greenLight;
}, function (_a) {
    var theme = _a.theme;
    return theme.green;
}, function (_a) {
    var theme = _a.theme;
    return theme.greenDark;
}, function (_a) {
    var theme = _a.theme;
    return theme.turquoiseLight;
}, function (_a) {
    var theme = _a.theme;
    return theme.turquoise;
}, function (_a) {
    var theme = _a.theme;
    return theme.turquoiseDark;
}, function (_a) {
    var theme = _a.theme;
    return theme.turquoise15;
}, function (_a) {
    var theme = _a.theme;
    return theme.turquoise30;
}, function (_a) {
    var theme = _a.theme;
    return theme.pinkLight;
}, function (_a) {
    var theme = _a.theme;
    return theme.pink;
}, function (_a) {
    var theme = _a.theme;
    return theme.pinkDark;
}, function (_a) {
    var theme = _a.theme;
    return theme.cyanLight;
}, function (_a) {
    var theme = _a.theme;
    return theme.meteor;
}, function (_a) {
    var theme = _a.theme;
    return theme.navy;
}, function (_a) {
    var theme = _a.theme;
    return theme.ozone;
}, function (_a) {
    var theme = _a.theme;
    return theme.gold;
}, function (_a) {
    var theme = _a.theme;
    return theme.goldLight;
}, function (_a) {
    var theme = _a.theme;
    return theme.redDark;
}, function (_a) {
    var theme = _a.theme;
    return theme.redDark10;
}, function (_a) {
    var theme = _a.theme;
    return theme.redLight;
}, function (_a) {
    var theme = _a.theme;
    return theme.lake;
}, function (_a) {
    var theme = _a.theme;
    return theme.perfGreen;
}, function (_a) {
    var theme = _a.theme;
    return theme.attention;
}, function (_a) {
    var theme = _a.theme;
    return theme.turquoise80;
}, function (_a) {
    var theme = _a.theme;
    return theme.danger80;
}, function (_a) {
    var theme = _a.theme;
    return theme.attention15;
}, function (_a) {
    var theme = _a.theme;
    return theme.attention40;
}, function (_a) {
    var theme = _a.theme;
    return theme.snowDarker25;
}, function (_a) {
    var theme = _a.theme;
    return theme.danger5;
}, function (_a) {
    var theme = _a.theme;
    return theme.danger15;
}, function (_a) {
    var theme = _a.theme;
    return theme.danger40;
}, function (_a) {
    var theme = _a.theme;
    return theme.turquoise5;
}, function (_a) {
    var theme = _a.theme;
    return theme.purple;
}, function (_a) {
    var theme = _a.theme;
    return theme.purple15;
}, function (_a) {
    var theme = _a.theme;
    return theme.purple40;
}, typography_1.default, shadows_1.default, function (_a) {
    var theme = _a.theme;
    return theme.themeName === "light" ? shadows_1.default : noShadows_1.default;
}, function (_a) {
    var theme = _a.theme;
    return theme.background;
}, function (_a) {
    var theme = _a.theme;
    return theme.background;
}, function (_a) {
    var theme = _a.theme;
    return theme.smoke;
}, function (_a) {
    var theme = _a.theme;
    return theme.steel;
}, function (_a) {
    var theme = _a.theme;
    return theme.snowDarker;
}, function (_a) {
    var theme = _a.theme;
    return theme.warning;
});
exports.default = CompassGlobalStyles;
var templateObject_1;
